module.exports = __webpack_public_path__ + "static/img/use-alto-create-copy.e7fbc39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marketing/use-alto-create-copy.png
// module id = Z074
// module chunks = 2